<script lang="ts">
export default {
  name: 'KkDocomoPostPreview',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import type { Post } from '../../types'
import { KkPostPreviewLayout } from '../../../../domains/post'

const store = useStore()
const post = computed<Post>(() => store.getters['companiesStorePosts/post'])
const showCallToActionType = computed<boolean>(() => store.getters['companiesStorePosts/showCallToActionType'])

const postTitle = computed<string>(() => {
  if (post.value.topicType === 'STANDARD') {
    return post.value.title ?? ''
  } else {
    return post.value.event.title ?? ''
  }
})

const summaryText = computed<string>(() => {
  if (post.value.topicType === 'STANDARD' && Boolean(postTitle.value)) {
    return `【${postTitle.value}】${post.value.summary ?? ''}`
  } else {
    return `${post.value.summary ?? ''}`
  }
})

// 60文字以上は…で省略
const truncatedSummary = computed<string>(() => {
  if (summaryText.value && summaryText.value.length > 60) {
    return summaryText.value.slice(0, 60) + '...'
  }

  return summaryText.value
})

const hasContent = computed<boolean>(() => {
  return Boolean(
    post.value.postImages.length ||
    post.value.title ||
    post.value.event.title ||
    post.value.summary ||
    (showCallToActionType.value && post.value.callToAction.actionType !== 'ACTION_TYPE_UNSPECIFIED'))
})
</script>
<template>
  <KkPostPreviewLayout service="docomo" :post="post" :has-content="hasContent">
    <!-- 写真 -->
    <div v-if="post.postImages.length" class="preview__imageWrapper">
      <img :src="post.postImages[0].url" :alt="`${post.postImages[0].id}`" class="preview__image">
    </div>

    <!-- 内容 -->
    <p v-show="truncatedSummary" class="preview__text">{{ truncatedSummary }}</p>
  </KkPostPreviewLayout>
</template>

<style lang="scss" scoped>
.preview {
  &__imageWrapper {
    padding-top: 12px;
  }

  &__image {
    margin: 2px;
    width: 100%;
  }

  &__text {
    padding: 12px 12px 0;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
